import { useState } from 'react';
import {
  ContainerListModal,
  fullScreenButtonClick,
  ImageGallery,
  ManageSalesDeleteModal,
  ManageSalesEditModal,
  ShareImagesModal,
} from '../../design-system';
import { ManageSalesPage, ManageSalesHeader, ManageSalesBody } from './ManageSalesComponents';
import { RoleGuard } from '../../routes';

export const ManageSales = () => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [checkIndexs, setCheckIndexs] = useState<number[]>([]);
  const [images, setImages] = useState<any>([]);
  const [containerList, setContainerList] = useState<any>();

  const handleCheckboxChange = (i: number) => {
    if (isNaN(i)) {
      const allCheckIndexs = Array.from({ length: data.length }, (_, i) => i);
      setCheckIndexs(checkIndexs.length === data.length ? [] : allCheckIndexs);
      return;
    }

    setCheckIndexs((prev) =>
      prev.includes(i) ? prev.filter((index) => index !== i) : [...prev, i],
    );
  };

  const handleClickImage = (images: any[]) => {
    setImages(images.map(({ url }) => url));
    fullScreenButtonClick();
  };

  return (
    <RoleGuard roles={['TRADER']} isMobile negative>
      <RoleGuard
        roles={[
          'SUPER_ADMIN',
          'YARD_COMPANY_ADMIN',
          'YARD_COMPANY_VIEWER',
          'YARD_MANAGER',
          'CLIENT_MANAGER',
          'CLIENT_DISPATCHER',
        ]}
      >
        <ManageSalesPage innerScroll>
          <ManageSalesHeader
            totalCount={totalCount}
            containerList={containerList}
            setContainerList={setContainerList}
          />
          <ManageSalesBody
            setData={setData}
            setTotalCount={setTotalCount}
            containerList={containerList}
            setContainerList={setContainerList}
            checkIndexs={checkIndexs}
            setCheckIndexs={setCheckIndexs}
            handleCheckboxChange={handleCheckboxChange}
            handleClickImage={handleClickImage}
          />
        </ManageSalesPage>
        <ContainerListModal validContainers />
        <ManageSalesEditModal />
        <ManageSalesDeleteModal />
        <ImageGallery photos={images} startIndex={0} />
        <ShareImagesModal />
      </RoleGuard>
    </RoleGuard>
  );
};
